export const filtredArrayBblsSumBolsSelectedMan = (getListMan, isMounted, setSumBBLSgross) => {
    const filtredBols = [];
    getListMan.forEach((item, index) => {
        const getBookingRef = getListMan[index]?.goods.map(el => el?.bol?.bblsGross)
        const setUniqElements = [...new Set(getBookingRef)].reduce((acc, el) => acc + el);
        filtredBols.push(setUniqElements);
    })
    isMounted && setSumBBLSgross(filtredBols);
}